<script setup lang="ts">
const {fetch: fetchBlogMeta} = useBlogMeta()
const articlesFetch = useArticles()
const {
  public: {baseUrl},
} = useRuntimeConfig()

const [{data: meta}, {data: articles}] = await Promise.all([
  useAsyncData('blog-meta', () => fetchBlogMeta()),
  useAsyncData('blog-page', () => articlesFetch.list()),
])

const seo = meta.value?.meta
useSeoMeta({
  title: seo?.title || 'Blog | Webamboos',
  description: seo?.description,
  ogUrl: `${baseUrl}/blog`,
  ogTitle: seo?.ogTitle || seo?.title,
  ogDescription: seo?.ogDescription || seo?.description,
  ogImage: resolveMediaUrl(seo?.image),
  ogImageAlt: resolveMediaAlt(seo?.image),
})
</script>

<template>
  <Container v-if="articles" class="screen-content min-h-screen px-0 pb-32 md:px-16">
    <LayoutPageHeader :title="$t('blog.title')" class="z-0" />

    <section class="mt-8 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
      <template v-for="(article, index) of articles" :key="article.id">
        <LargeArticlePreview v-if="index === 0 || index % 5 === 0" :article="article" class="relative sm:col-span-2" />
        <ArticlePreview v-else :article="article" />
      </template>
    </section>
  </Container>
</template>
